(function () {
	'use strict';

	/* M1o2 cart drawer supplements - only the bits Dawn's cart.js / cart-drawer.js do NOT cover:
	   (1) upsell size-pill selection, (2) upsell "ADD" -> /cart/add.js then re-render the drawer,
	   (3) refresh the header item count + free-shipping progress after an external cart change.
	   Dawn owns open/close, Escape, scroll-lock, focus-trap, qty steppers, remove, and the
	   items/subtotal re-render. No globals; event delegation so listeners survive re-renders. */

	var SECTION_ID = 'cart-drawer';

	function cartUrl() {
		return (window.routes && window.routes.cart_url) || '/cart';
	}

	function addUrl() {
		return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
	}

	/* ---- Upsell: size-pill selection ---- */
	function selectPill(pill) {
		var card = pill.closest('[data-upsell-card]');
		if (!card) return;
		var pills = card.querySelectorAll('.m1o2-cart-drawer__pill');
		Array.prototype.forEach.call(pills, function (p) {
			var selected = p === pill;
			p.classList.toggle('is-selected', selected);
			p.setAttribute('aria-pressed', selected ? 'true' : 'false');
		});
		var addBtn = card.querySelector('[data-upsell-add]');
		if (!addBtn) return;
		var variantId = pill.getAttribute('data-upsell-variant');
		if (variantId) addBtn.setAttribute('data-upsell-id', variantId);
		var priceEl = addBtn.querySelector('[data-upsell-add-price]');
		var price = pill.getAttribute('data-upsell-price');
		if (priceEl && price) priceEl.textContent = price;
	}

	/* ---- Refresh header count + free-shipping progress (they live outside cart-drawer-items,
	   which Dawn's onCartUpdate replaces on its own, so we re-render them from fresh Liquid).
	   If the page loaded with an empty cart there is no cart-drawer-items at all (the snippet
	   renders only the empty state), so nothing would ever draw the new lines: the header said
	   "1 Item" over "Your cart is empty". In that case the whole #CartDrawer is swapped, as
	   Dawn's CartDrawer.renderContents does for its own product form. ---- */
	var refreshing = false;
	var refreshAgain = false;
	function refreshHeaderAndFreeship() {
		if (refreshing) {
			/* a change landed mid-fetch: run once more after, so the drawer never settles stale */
			refreshAgain = true;
			return Promise.resolve();
		}
		refreshing = true;
		return fetch(cartUrl() + '?section_id=' + SECTION_ID)
			.then(function (response) {
				return response.text();
			})
			.then(function (text) {
				var doc = new DOMParser().parseFromString(text, 'text/html');
				var drawer = document.querySelector('cart-drawer');
				var current = document.getElementById('CartDrawer');
				var fresh = doc.getElementById('CartDrawer');
				if (drawer && current && fresh && fresh.querySelector('cart-drawer-items') && !current.querySelector('cart-drawer-items')) {
					current.innerHTML = fresh.innerHTML;
					drawer.classList.remove('is-empty');
					var overlay = current.querySelector('#CartDrawer-Overlay');
					if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
					return;
				}
				['.m1o2-cart-drawer__header', '.m1o2-cart-drawer__freeship'].forEach(function (selector) {
					var el = document.querySelector(selector);
					var freshEl = doc.querySelector(selector);
					if (el && freshEl) el.innerHTML = freshEl.innerHTML;
				});
			})
			.catch(function () {
				/* leave stale values rather than break the drawer */
			})
			.finally(function () {
				refreshing = false;
				if (refreshAgain) {
					refreshAgain = false;
					refreshHeaderAndFreeship();
				}
			});
	}

	/* ---- Broadcast a cart change so Dawn's cart-drawer-items refreshes items + subtotal ---- */
	function broadcastCartUpdate() {
		return fetch(cartUrl() + '.js')
			.then(function (response) {
				return response.json();
			})
			.then(function (cart) {
				if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'm1o2-cart-drawer', cartData: cart });
				} else {
					var items = document.querySelector('cart-drawer-items');
					if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
					refreshHeaderAndFreeship();
				}
			})
			.catch(function () {
				var items = document.querySelector('cart-drawer-items');
				if (items && typeof items.onCartUpdate === 'function') items.onCartUpdate();
				refreshHeaderAndFreeship();
			});
	}

	/* ---- Upsell: ADD -> /cart/add.js ---- */
	function addUpsell(addBtn) {
		var variantId = addBtn.getAttribute('data-upsell-id');
		if (!variantId || addBtn.getAttribute('aria-busy') === 'true') return;
		addBtn.setAttribute('aria-busy', 'true');
		fetch(addUrl(), {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
		})
			.then(function (response) {
				return response.json().then(function (data) {
					if (!response.ok) throw new Error((data && data.description) || 'Add to cart failed');
					return data;
				});
			})
			.then(function () {
				return broadcastCartUpdate();
			})
			.catch(function () {
				var errors = document.getElementById('CartDrawer-CartErrors');
				if (errors) errors.textContent = 'Sorry, we could not add that item.';
			})
			.finally(function () {
				addBtn.removeAttribute('aria-busy');
			});
	}

	/* ---- Delegated interactions (survive drawer re-renders) ---- */
	document.addEventListener('click', function (event) {
		var pill = event.target.closest('.m1o2-cart-drawer__pill');
		if (pill && !pill.hasAttribute('disabled')) {
			selectPill(pill);
			return;
		}
		var addBtn = event.target.closest('[data-upsell-add]');
		if (addBtn) {
			event.preventDefault();
			addUpsell(addBtn);
		}
	});

	/* ---- Keep header count + progress in sync on external cart changes.
	   Skip 'cart-items' (that path re-renders the whole .drawer__inner already). ---- */
	/* Cart changes made outside Dawn's pub/sub (home / landing / collection / PDP card scripts)
	   arrive through the global watcher in assets/m1o2-main.js. Their lines must be drawn too,
	   so cart-drawer-items is asked to re-render as well when it exists. */
	document.addEventListener('m1o2:cart:changed', function (event) {
		var cart = event.detail && event.detail.cart;
		var items = document.querySelector('cart-drawer-items');
		if (items && typeof items.onCartUpdate === 'function' && cart) {
			/* Skip when the drawer already shows this cart (its own steppers re-render it). */
			var shown = 0;
			Array.prototype.forEach.call(items.querySelectorAll('input[name="updates[]"]'), function (input) {
				shown += parseInt(input.value, 10) || 0;
			});
			if (shown !== cart.item_count) items.onCartUpdate();
		}
		refreshHeaderAndFreeship();
	});

	if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
		subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
			if (event && event.source === 'cart-items') return;
			refreshHeaderAndFreeship();
		});
	}
})();
